/**
 * Use this file for JavaScript code that you want to run in the front-end 
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any 
 * JavaScript running in the front-end, then you should delete this file and remove 
 * the `viewScript` property from `block.json`. 
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */

class GSSTabs {
    constructor(tabs) {
        this.grabElements(tabs);
        this.bindEvents();
        this.setDefault();
    }

    grabElements(tabs) {
        this.tabButtons = tabs.querySelectorAll('button[role="tab"]');
        this.panels = tabs.querySelectorAll('div[role="tabpanel"]');
    }

    bindEvents() {
        this.tabButtons.forEach(button => {
            button.addEventListener('click', () => {
                this.changeTab(button.dataset.tab);
            });
        });
    }

    changeTab(tabId) {
        this.tabButtons.forEach(button => {
            if (button.dataset.tab === tabId) {
                button.setAttribute('aria-expanded', 'true');
                button.classList.add('active');
            } else {
                button.setAttribute('aria-expanded', 'false');
                button.classList.remove('active');
            }
        });
        this.panels.forEach(panel => {
            if (panel.id === tabId) {
                panel.classList.add('active');
            } else {
                panel.classList.remove('active');
            }
        });
    }

    setDefault() {
        this.changeTab(this.tabButtons[0].dataset.tab);
    }
}
 
document.querySelectorAll('.wp-block-gss-tabs').forEach(tabs => {
    new GSSTabs(tabs);
});
